import request from '@/http/request'

export const getReworkSummaryData = params => {
  return request.post(`${process.env.REACT_APP_RFID_API_URL}/rfid-report-service/ib/rework/report/detail`, params)
}

export const getReworkSummaryDataDownload = params => {
  return request.post(
    `${process.env.REACT_APP_RFID_API_URL}/rfid-report-service/ib/rework/report/export/detail`,
    params,
    {
      responseType: 'blob',
      uploadOrDownload: true
    }
  )
}
